import React from 'react';
import { shotSrcSet } from './shots';
import { BrandButton, Highlight, Kicker, assetUrl } from './ui';

/*
 * Figma "Hero" (node 35706:861). Measured from the 1800px frame:
 * kicker 99px below the nav, laptop 1141×700, stats row 90px below the laptop.
 */
const HeroSection = ({ hero, onAuth }) => (
  <section id="hero" className="relative isolate" data-testid="hero-section">
    {/* Mint wave behind the laptop, bleeding past both edges like in Figma */}
    <img
      src="/brand/blob.svg"
      alt=""
      aria-hidden
      className="pointer-events-none absolute left-[-4.3889vw] top-[14.6667vw] -z-10 h-[69.3889vw] w-[106vw] max-w-none select-none"
    />

    <div className="hp-container pt-[clamp(48px,5.5vw,99px)] text-center">
      <Kicker className="text-brand-navy">{hero.kicker}</Kicker>

      <h1 className="hp-display mx-auto mt-[clamp(18px,1.3333vw,24px)] max-w-[12.04em] text-[#273845]">
        <Highlight text={hero.title} />
      </h1>

      <p className="mx-auto mt-[clamp(12px,1.0556vw,19px)] max-w-[33.55em] text-[clamp(17px,1.3333vw,24px)] font-medium leading-[1.6667] text-[#273845]">
        {hero.subtitle}
      </p>

      <div className="mt-[clamp(24px,1.9444vw,35px)] flex flex-col items-center justify-center gap-3 min-[420px]:flex-row min-[420px]:gap-5">
        <BrandButton to="register" onAuth={onAuth} data-testid="hero-cta-button" className="w-full min-[420px]:w-auto">
          {hero.cta_primary}
        </BrandButton>
        <BrandButton
          to={hero.cta_secondary_link}
          onAuth={onAuth}
          variant="outline"
          data-testid="hero-secondary-cta"
          className="w-full min-[420px]:w-auto"
        >
          {hero.cta_secondary}
        </BrandButton>
      </div>

      {/* Laptop mockup with the live dashboard screenshot placed on its screen */}
      <div className="relative mx-auto mt-[clamp(36px,3.8333vw,69px)] aspect-[1141/700] w-full max-w-[1141px]">
        <img
          src="/brand/hero-laptop.webp"
          alt=""
          aria-hidden
          className="absolute inset-0 h-full w-full object-contain"
        />
        <div className="absolute left-[8.94%] top-[1.14%] h-[87.86%] w-[82.38%] overflow-hidden rounded-[1.7%/2.6%]">
          <img
            src={assetUrl(hero.image_url)}
            srcSet={shotSrcSet(hero.image_url)}
            sizes="(min-width: 1141px) 1141px, 100vw"
            fetchPriority="high"
            decoding="async"
            alt="WowProfit.io dashboard"
            className="absolute left-0 top-0 h-full w-[107.3%] max-w-none object-cover object-left-top"
            data-testid="hero-app-shot"
          />
        </div>
      </div>

      {/* Stats row */}
      <dl className="mt-[clamp(40px,5vw,90px)] grid grid-cols-2 gap-y-8 lg:grid-cols-4" data-testid="trust-bar">
        {hero.stats.map((stat, i) => (
          <div
            key={i}
            className={`relative flex flex-col items-center px-3 lg:h-[188px] lg:pt-[42px] ${
              i < hero.stats.length - 1 ? 'lg:border-r lg:border-[#243746]/20' : ''
            } ${i % 2 === 0 ? 'max-lg:border-r max-lg:border-[#243746]/20' : ''}`}
          >
            <dt className="order-2 mt-[clamp(10px,0.8333vw,15px)] max-w-[341px] text-[clamp(15px,1.3333vw,24px)] font-medium leading-[1.5417] text-black">
              {stat.label}
            </dt>
            <dd className="hp-stat order-1 whitespace-nowrap text-[#2b2b2b]">
              <Highlight text={stat.value} />
            </dd>
          </div>
        ))}
      </dl>
    </div>
  </section>
);

export default HeroSection;
